import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Subject, takeUntil } from 'rxjs';
import { GenericClass } from 'src/app/model/genericClass';


import { ExecutionAuditFilter, ExecutionQAuditFilter } from 'src/app/model/execution';
import { TestQTypeService } from 'src/app/services/testQType.service';
import { CustomDatepickerHeaderComponent } from 'src/app/components/shared/datepicker-custom-header/datepicker-custom-header.component';

@Component({
    selector: 'app-execution-edit-q-audit-list-filter',
    templateUrl: './execution-edit-q-audit-list-filter.component.html',
    standalone: false,
})
export class ExecutionEditQAuditListQFilterComponent implements OnInit {

  @Output() filterEmitter = new EventEmitter<ExecutionQAuditFilter>();
  
  filter: ExecutionQAuditFilter;
  form: FormGroup;
  isList: boolean;
  private destroy$ = new Subject<void>();
  expandedFilter = true;
  typeQTypes:GenericClass[];
  customDatepickerHeader = CustomDatepickerHeaderComponent;

  constructor(
    fb: FormBuilder,
    private testQTypeService: TestQTypeService
    ) {
      this.cleanFilter();

    this.form = fb.group({
      idTestType: [this.filter.idTestType]
    });
    
  }

  ngOnInit(): void {
    this.typeQTypes = [];
    this.testQTypeService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: GenericClass[]) => this.typeQTypes = data);
    this.form.get('idTestType').valueChanges.pipe(takeUntil(this.destroy$))
    .subscribe(value => {
      this.filter.idTestType = value;
    });
  }

  cleanFilter(): void {
    this.filter = new ExecutionQAuditFilter();
    this.doFilter();
  }

  doFilter(): void {
    this.expandedFilter = false;
    this.filterEmitter.emit(this.filter);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  saveDate(field: string, event: MatDatepickerInputEvent<Date>): void {

    let dateValue = event.value;
    if (dateValue != null) {   
      this.filter[field] = new Date(dateValue);
    } else {
      this.filter[field] = null;
    }
  }
}
